import React from 'react'
import { Col, Flex, Form, Input, Row, Select, Tooltip } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import './index.scss'
import { useSelector } from 'react-redux'

interface Props {
  control: any
}

function ClientInfo(props: Props) {
  const { control } = props
  const { t } = useTranslation()

  const timeZoneList = useSelector((state: any) => state?.masterSetup?.timeZoneList)

  return (
    <Flex vertical>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label={t('ClientSetup:addNewClient.label.clientName')} className='isRequired'>
            <Controller
              name='clientName'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>

          <Form.Item label={t('ClientSetup:addNewClient.label.referenceCode')}>
            <Controller
              name='referenceCode'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>

          <Form.Item label={t('ClientSetup:addNewClient.label.timeZone')} className='isRequired'>
            <Controller
              name='timeZoneId'
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={timeZoneList?.map((item: any) => ({
                    ...item,
                    value: item?.id,
                    label: item?.applicationName,
                  }))}
                />
              )}
              disabled
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label={t('ClientSetup:addNewClient.label.clientID')} className='isRequired'>
            <Controller
              name='clientNumber'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>

          <Form.Item
            label={
              <Tooltip
                placement='right'
                title={t('ClientSetup:addNewClient.tooltip.clientNotes')}
                color='white'
                trigger='hover'
                arrow={false}
              >
                <Flex gap={9}>
                  {t('ClientSetup:addNewClient.label.clientNotes')}
                  <ExclamationCircleOutlined />
                </Flex>
              </Tooltip>
            }
          >
            <Controller
              name='clientNotes'
              control={control}
              render={({ field }) => (
                <Tooltip
                  placement='topRight'
                  overlayClassName='clientNoteTooltips'
                  title={field?.value}
                  color='white'
                  trigger='hover'
                  arrow={false}
                >
                  <Input {...field} className='ant-input-view-only' />
                </Tooltip>
              )}
              disabled
            />
          </Form.Item>

          <Form.Item label={t('ClientSetup:addNewClient.label.exceptionReminderEmailTime')} className='isRequired'>
            <Controller
              name='exceptionReminderEmailTimeInMinutes'
              control={control}
              render={({ field }) => <Input {...field} className='ant-input-view-only' />}
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
    </Flex>
  )
}

export default ClientInfo
